import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GeoPhone from "./GeoData";
import { useModal } from "../contexts/ModalContext";
import { BaseUrl } from "../helper/BaseUrl";
import MobileMenu from "./MobileMenu";
import {
  brandOrderMap,
  byConfiguredOrder,
  byProductTitle,
  typeOrderMap,
} from "../helper/ProductMenuOrder";

export default function Header({ initialData }) {
  const { openQueryModal } = useModal();

  const [isOpen, setIsOpen] = useState(false);
  const [isScroll, setIsScroll] = useState(false);

  const [level, setLevel] = useState(1);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeBrand, setActiveBrand] = useState(null);
  const [activeType, setActiveType] = useState(null);

  const [allData, setAllData] = useState(initialData || {});
  const [hasFetchedMenu, setHasFetchedMenu] = useState(false);

  // ================= SCROLL =================
  useEffect(() => {
    const handleScroll = () => setIsScroll(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  // ================= API =================
  const fetcher = async () => {
    if (hasFetchedMenu) {
      return;
    }

    try {
      setHasFetchedMenu(true);
      const response = await fetch(`${BaseUrl}/api/allproducts`);
      const result = await response.json();

      const products = result.products;
      const formattedData = {};

      products.forEach((item) => {
        const category = item.category_name;
        const brand = item.brand;
        const type = item.type;

        if (!formattedData[category]) {
          formattedData[category] = {
            created_at: item.category_created_at,
            category_slug: item.category_slug,
            brands: {},
          };
        }

        // ✅ BRAND OBJECT
        if (!formattedData[category].brands[brand]) {
          formattedData[category].brands[brand] = {};
        }

        // ✅ TYPE OBJECT
        if (!formattedData[category].brands[brand][type]) {
          formattedData[category].brands[brand][type] = [];
        }

        // ✅ PRODUCTS
        formattedData[category].brands[brand][type].push({
          title: item.title,
          slug: item.slug,
        });
      });

      setAllData(formattedData);
    } catch (error) {
      setHasFetchedMenu(false);
      console.error("Fetch error:", error.message);
    }
  };

  useEffect(() => {
    const scheduleMenuFetch = () => {
      if (typeof window !== "undefined" && "requestIdleCallback" in window) {
        return window.requestIdleCallback(fetcher, { timeout: 4000 });
      }

      return setTimeout(fetcher, 2000);
    };

    const fetchId = scheduleMenuFetch();

    return () => {
      if (typeof window !== "undefined" && "cancelIdleCallback" in window) {
        window.cancelIdleCallback(fetchId);
        return;
      }

      clearTimeout(fetchId);
    };
  }, [hasFetchedMenu]);

  // ================= CATEGORY LIST =================
  const categories = Object.entries(allData || {})
    .sort((a, b) => new Date(a[1].created_at) - new Date(b[1].created_at))
    .map(([key, value]) => ({
      name: key,
      slug: value.category_slug,
    }));

  return (
    <>



      <div className={`header-space ${isScroll ? "header-fixed" : ""}`} >
        <header className="header">
          <div className="header-top">
            <div className="container">
              <div className="row top-header-row">
                <div className="d-none d-sm-block  col-3 col-sm-3 col-md-4 col-lg-6">
                  <div className="header-social">
                    <ul>
                      {/* <li>
                    <a href="https://www.facebook.com/share/1A6nhWDeu9/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a>
                    </li> */}
                      <li>
                        <a href="https://www.linkedin.com/company/supershine-laundry-official/" target="_blank" rel="noopener noreferrer">
                          <span className="follow-us">Follow Us :</span>
                          <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                      </li>
                      {/* <li>
                    <Link><i className="fa-brands fa-x-twitter"></i></Link>   </li>
                    <li>  <Link><i className="fa-brands fa-youtube"></i></Link>  </li> */}
                    </ul>
                  </div>
                </div>
                <div className=" col-12 col-sm-9 col-md-8 col-lg-6" >
                  <div className="header-right-sec">
                    <div className="header-address">
                      <div className="number-text first-number">
                        {/* <Link to="tel:+91-124-4807600">
                       <img src="/assets/images/call-icons.webp" alt="Call" className="img-responsive" />+91-124-4807600
                      </Link> */}
                        <GeoPhone />
                      </div>
                    </div>
                    <div className="header-address">
                      <div className="number-text">
                        <Link to="mailto:sales@supershinelaundry.ae">
                          <img src="/assets/images/mail-icons.webp" alt="Call" className="img-responsive" width="31" height="22" decoding="async" />sales@supershinelaundry.ae
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header-bottom">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-5 col-sm-6 col-md-6 col-lg-3">
                  <div className="header-logo">
                    <Link to={"/"}><img src="/assets/images/header-logos.webp" alt="Supershine" className="img-responsive" width="1538" height="287" fetchPriority="high" decoding="async" /> </Link>
                  </div>
                </div>
                <div className="d-none d-lg-block col-lg-7" >
                  <div className="header-menus">
                    <div className="header-menus-sec">
                      <div className="menu-item">
                        <ul className="item menu-items">
                          <li className="child-item">
                            <Link className="item-link" >  Company  </Link>
                            <div className="nav-dropdown">
                              <ul>
                                <li><Link to="/about">About Us</Link></li>
                                <li><Link to="/contact">Contact</Link></li>
                                {/* <li><Link to="/about#our-team">Our Team</Link></li> */}
                                <li><Link to="/careers">career</Link></li>
                              </ul>
                            </div>
                          </li>
                          <li className="child-item" onMouseEnter={fetcher} onMouseLeave={() => {
                            setLevel(1); setActiveCategory(null); setActiveBrand(null); setActiveType(null);
                          }} >
                            <Link className="item-link" to={"/product-listing"}>Products</Link>
                            <div className="nav-dropdown mega-menu">
                              <div className={`mega-container level-${level}`}>
                                <div className="mega-col">
                                  <div className="nav-dropdown-label"> Products</div>
                                  <ul>
                                    {categories.map((cat, i) => (
                                      <li key={i} onMouseEnter={() => {
                                        setLevel(2); setActiveCategory(cat.name);
                                        setActiveBrand(null); setActiveType(null);   }}  >
                                        <Link to={`/product-listing/${cat.slug}`}>{cat.name}<i className="fa-solid fa-angle-down"></i> </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                {/* BRAND */}
                                <div className="mega-col product-col-border">
                                  <div className="nav-dropdown-label">Brands</div>
                                  <ul>
                                    {activeCategory &&
                                      Object.keys(allData[activeCategory]?.brands || {})
                                        .filter((brand) => brand && brand.trim() !== "")
                                        .sort(byConfiguredOrder(brandOrderMap))
                                        .map((brand, i) => (
                                          <li key={i} className={activeBrand === brand ? "active" : ""}
                                            onMouseEnter={() => { setLevel(3); setActiveBrand(brand); setActiveType(null); }}  >
                                            <span>{brand} <i className="fa-solid fa-angle-down"></i> </span>
                                          </li>
                                        ))}
                                  </ul>
                                </div>
                                <div className="mega-col product-col-border2">
                                  <div className="nav-dropdown-label">Type</div>
                                  <ul>
                                    {activeCategory &&
                                      activeBrand &&
                                      Object.keys(
                                        allData[activeCategory]?.brands?.[activeBrand] || {}
                                      )
                                        .filter((type) => type && type.trim() !== "")
                                        .sort(byConfiguredOrder(typeOrderMap))
                                        .map((type, i) => (
                                          <li key={i} className={activeType === type ? "active" : ""}
                                            onMouseEnter={() => {
                                              setLevel(4); setActiveType(type);
                                            }} >
                                            <span>{type} <i className="fa-solid fa-angle-down"></i> </span>
                                          </li>
                                        ))}
                                  </ul>
                                </div>
                                {/* PRODUCTS */}
                                <div className="mega-col mega-col">
                                  <div className="nav-dropdown-label">Name</div>
                                  <ul className="scroll-bar">
                                    {activeCategory &&
                                      activeBrand &&
                                      activeType &&
                                      allData[activeCategory]?.brands?.[activeBrand]?.[
                                        activeType
                                      ]?.slice()
                                        .sort(byProductTitle)
                                        .map((item, i) => (
                                        <li key={i}> <Link to={`/product/${item.slug}`}>  {item.title}     </Link>  </li>
                                      ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="child-item">
                            <Link className="item-link" >  Services  </Link>
                            <div className="nav-dropdown  extrawide">
                              <div className="nav-dropdown-label">Services </div>
                              <ul className="service-child">
                                <li>
                                  <div className="item">
                                    <Link to="/project-planing" >
                                      <label>Assessment & Project Planing</label>
                                      <p>Site evaluation, equipment selection, and end-to-end laundry project planning.</p>
                                    </Link>
                                  </div>
                                </li>
                                <li>
                                  <div className="item">
                                    <Link to="/delivery">
                                      <label>Delivery</label>
                                      <p>Timely, damage-free equipment delivery coordinated across locations pan-India.</p>
                                    </Link>
                                  </div>
                                </li>
                                <li>
                                  <div className="item">
                                    <Link to="/installation" > <label>Installation </label>
                                      <p>Precise installation by trained engineers for lasting performance from day one.</p>
                                    </Link>
                                  </div>
                                </li>
                                <li>
                                  <div className="item">
                                    <Link to="/training" > <label>Training</label>
                                      <p>Hands-on operator training ensuring your team.</p>
                                    </Link>
                                  </div>
                                </li>
                                <li>
                                  <div className="item">
                                    <Link to="/sales-service" > <label>After Sales Service</label>
                                      <p>Responsive service support, spare parts, and maintenance to minimise downtime.</p>
                                    </Link>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li className="child-item">
                            <Link className="item-link" >   Industries </Link>
                            <div className="nav-dropdown  wide">
                              <div className="nav-dropdown-label">INDUSTRIES</div>
                              <ul className="industries-child">
                                <li><Link to="/hospitality-laundry-washing-machine-system" >Hospitality</Link></li>
                                <li><Link to="/heathcare-medical-grade-commercial-laundry">Healthcare</Link></li>
                                <li><Link to="/pharmaceutical-grade-commercial-laundry" >Pharma</Link></li>
                                <li><Link to="/commercial-washing-machine-for-university" >Education</Link></li>
                                <li><Link to="/commercial-laundry-washing-machine" >Commercial Laundry</Link></li>
                                <li><Link to="/industrial-laundromat-washing-machines" >Laundromat</Link></li>
                                <li><Link to="/railway-grade-commercial-laundry-machine" >Railways</Link></li>
                                <li><Link to="/defence-grade-commercial-laundry-machine" >Defence</Link></li>
                                <li><Link to="/commercial-laundry-for-garment-manufacturing">Garments</Link></li>
                              </ul>
                            </div>
                          </li>
                          <li className="child-item">
                            <Link className="item-link" >  Insights  </Link>
                            <div className="nav-dropdown">
                              <ul>
                                <li><Link to="/project">Projects</Link></li>
                                <li><Link to="/blog">Blogs</Link></li>
                                <li><Link to="/news">News</Link></li>
                                <li><Link to="/faq">Faqs</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-7 col-sm-6 col-md-6 col-lg-2">
                  <div className="header-button">
                    <Link onClick={openQueryModal} className="default-btn white-btn"><span>Enquire Now</span></Link>
                    <div className={`menu-humberger ${isOpen ? "close-sign" : ""}`} onClick={toggleMenu}>
                      <div className="menu-toogle"><div className="menu-line icon-top"></div><div className="menu-line icon-center"></div><div className="menu-line icon-bottom"></div></div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
        <MobileMenu isOpen={isOpen} setIsOpen={setIsOpen} allData={allData} />
      {/* <MobileMenu isOpen={isOpen} closeMenu={() => setIsOpen(false)} allData={allData} /> */}
    </>
  );
}
